module.exports = __webpack_public_path__ + "img/skull_2.26858074.webp";